
	// @ts-nocheck  (визард собирается, а юарм - нет, и наоборот. Надо что-то делать)
	import ctrlMixins from '@uarm/src/controls/_mixins.js'
	import datetime from './datetime.vue'
	import { ctrlParamsForAll } from '@uarm/src/controls/_common-stuff.ts';
	/** Двойной контрол датавремя для фильтрации по диапазону, см. getFilterControlComponent в p_list.vue */

	export default {
		name: 'ctrl_datetime_double',
		mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				default: function(){
					return [null,null]
				}
			},
		},
		meta: {
			...ctrlParamsForAll,
		},
		data: function(){
			//console.log(ctrlMixins.props, Object.keys(this.$props))
			var propsWithoutValue = Object.assign({ is_double: true, }, this.$props);
			delete propsWithoutValue.value;
			return {
				propsWithoutValue
			}
		},
		computed: {},
		components: {
			datetime
		},
		methods: {
			onUpdate: function(index, newVal){ // это апдейт дейтпикеров "снизу" и передача его значений "наверх" в фильтр
				// console.log('Double datepicker', index, newVal);
				var valueArray = [];
				valueArray[index] = newVal;
				var anotherIndex = index ? 0 : 1;
				valueArray[anotherIndex] = this.$props.value[anotherIndex];
				this.$emit('update:value', valueArray);
			},
		}
	}
